import { render, staticRenderFns } from "./or-clause.vue?vue&type=template&id=3b45df09&scoped=true"
import script from "./or-clause.vue?vue&type=script&lang=js"
export * from "./or-clause.vue?vue&type=script&lang=js"
import style0 from "./or-clause.vue?vue&type=style&index=0&id=3b45df09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b45df09",
  null
  
)

export default component.exports